import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { WisoryButton } from 'components/WisoryButton';
import { PrevButton } from 'components/PrevButton';
import { BookingFormLayout } from 'pages/profile/components/Layout';
import { ProfileFooter } from 'pages/profile/components/Layout/components/ProfileFooter';
import { BookingFormContext } from 'pages/profile/context2';
import { useContext, useEffect } from 'react';
import { GuestForm } from './components/GuestForm';
import { UserForm } from './components/UserForm';

export function LoginOrGuestStep() {
  const { t } = useTranslation();
  const { state, setStep } = useContext(BookingFormContext);

  const onGoBack = () => {
    setStep('enter-goal-and-purpose');
  };

  const goBackToLoginOrGuest = () => {
    setStep('login-or-enter-as-guest');
  };

  const onUserStepClick = () => {
    setStep('login-form');
  };

  const onAnonymousStepClick = () => {
    setStep('guest-form');
  };

  const onSubmitSuccess = () => {
    setStep('confirm-booking');
  };

  useEffect(() => {
    // If it is logged user, we move directly to confirm step
    if (state.customerInfo.isWisoryUser && state.customerInfo.customerName) {
      onSubmitSuccess();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (state.step === 'guest-form') {
    return <GuestForm onPrevBtnCick={goBackToLoginOrGuest} onSubmitSuccess={onSubmitSuccess} />;
  }

  if (state.step === 'login-form') {
    return <UserForm onPrevBtnCick={goBackToLoginOrGuest} onSubmitSuccess={onSubmitSuccess} />;
  }

  return (
    <BookingFormLayout
      footer={
        <ProfileFooter className="flex justify-between">
          <PrevButton type="button" onClick={onGoBack}>
            {t('REACT_BOOKING_FRONTEND.common.backButton')}
          </PrevButton>
          <div />
        </ProfileFooter>
      }
    >
      <div className={clsx('wisory-title', 'mb-9', 'font-openSans')}>
        {t('REACT_BOOKING_FRONTEND.booking2.loginOrGuest.title')}
      </div>
      <div className="flex gap-7 sm:flex-row flex-col">
        <div className="sm:w-1/2 w-full">
          <div className="text-black font-openSans font-bold mb-3">
            {t('REACT_BOOKING_FRONTEND.booking2.loginSectionTitle')}
          </div>
          <div className="text-black font-openSans mb-5">
            {t('REACT_BOOKING_FRONTEND.booking2.loginSectionDescription')}
          </div>
          <WisoryButton className="w-full" variant="primary" onClick={onUserStepClick}>
            {t('REACT_BOOKING_FRONTEND.booking2.loginSectionBtn')}
          </WisoryButton>
        </div>
        <div className="sm:w-1/2 w-full">
          <div className="text-black font-openSans font-bold mb-3">
            {t('REACT_BOOKING_FRONTEND.booking2.anonymousSectionTitle')}
          </div>
          <div className="text-black font-openSans mb-5">
            {t('REACT_BOOKING_FRONTEND.booking2.anonymousSectionDescription')}
          </div>
          <WisoryButton className="w-full" variant="primary" onClick={onAnonymousStepClick}>
            {t('REACT_BOOKING_FRONTEND.booking2.anonymousSectionBtn')}
          </WisoryButton>
        </div>
      </div>
    </BookingFormLayout>
  );
}
